var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282D2D",
    d: "m4.132 16.086.668.703c.176.14.457.14.597 0l6.399-6.363 6.363 6.363c.14.14.422.14.598 0l.668-.703a.404.404 0 0 0 0-.598l-7.348-7.383a.476.476 0 0 0-.598 0l-7.347 7.383a.405.405 0 0 0 0 .598"
  })));
};
export default SvgChevronUp;